import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { hasRequiredPermission } from '@cawita/core-front/auth';
import { CwtDirectiveView } from '@cawita/core-front/common';
import { Subscription } from 'rxjs';
import { ClientStore } from './client.store';

export type HasClientPermissionContext = {
    $implicit: boolean;
    cwtHasClientPermission: boolean;
}

/**
 * Exposes a boolean value
 * Input format: 'permission' or ['perm1', 'perm2']
 */
@Directive({ selector: '[cwtHasClientPermission]' })
export class HasClientPermissionDirective implements OnDestroy, OnInit {
    private _sub: Subscription;
    private _ctx: HasClientPermissionContext = { $implicit: false, cwtHasClientPermission: false };
    private _view = new CwtDirectiveView(this.vcRef, this.tRef, this._ctx);

    @Input('cwtHasClientPermission') set permissions(permissions: string | string[]) {
        if (this._sub) this._unsubscribe();
        this._sub = this.clientStore.state$.subscribe(() => {
            const hasPermission = this.clientStore.hasRequiredPermissions(permissions);
            this._ctx.$implicit = this._ctx.cwtHasClientPermission = hasPermission;
        });
    }

    constructor(
        private tRef: TemplateRef<any>,
        private vcRef: ViewContainerRef,
        private clientStore: ClientStore
    ) {
    }

    ngOnInit(): void {
        this._view.ensureState(true);
    }

    ngOnDestroy(): void {
        this._unsubscribe();
    }

    private _unsubscribe() {
        this._sub?.unsubscribe();
        this._sub = null;
    }
}
